import React from "react";
import { SettingsModal } from "../features/translator/components/SettingsModal";
import { DocsModal } from "../features/translator/components/DocsModal";
import { SummaryModal } from "../features/translator/components/SummaryModal";
import { ProfileModal } from "../features/auth/components/ProfileModal";
import { HistoryModal } from "../features/history/components/HistoryModal";
import { StopConfirmModal } from "../features/translator/components/StopConfirmModal";
import type { UseTranslatorReturn } from "../features/translator/hooks/useTranslator";

interface ModalsContainerProps {
  modals: ReturnType<typeof import("../hooks/useAppModals").useAppModals>;
  auth: UseTranslatorReturn;
  onStopConfirm: () => void;
}

export const ModalsContainer: React.FC<ModalsContainerProps> = ({ modals, auth, onStopConfirm }) => {
  return (
    <>
      <SettingsModal
        isOpen={modals.settingsOpen}
        onClose={() => modals.setSettingsOpen(false)}
        onSave={auth.saveSettings}
        initialSettings={auth.settings}
      />

      <DocsModal
        isOpen={modals.docsOpen}
        onClose={() => modals.setDocsOpen(false)}
      />

      <SummaryModal
        isOpen={modals.summaryOpen}
        onClose={modals.closeSummary}
        meetingTranscript={auth.meetingTranscript}
        currentMeetingId={modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting._id.toString() : auth.currentMeetingId}
        summaryServiceUrl={auth.settings.summaryServiceUrl}
        targetLang={modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting.target_lang : auth.tgtLang}
        targetLangLabel={auth.getLanguageLabel(modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting.target_lang : auth.tgtLang)}
        initialSummaryText={modals.savedSummaryModalData?.summaryText}
        isSavedSummary={!!modals.savedSummaryModalData}
      />

      <ProfileModal
        isOpen={modals.profileOpen}
        onClose={() => modals.setProfileOpen(false)}
        userServiceUrl={auth.settings.userServiceUrl}
      />

      <HistoryModal
        isOpen={modals.historyOpen}
        onClose={() => modals.setHistoryOpen(false)}
        translatorServiceUrl={auth.settings.translatorServiceUrl}
        onLoadMeeting={auth.loadPastMeeting}
        recording={auth.recording}
      />

      <StopConfirmModal
        isOpen={modals.stopConfirmOpen}
        onClose={() => modals.setStopConfirmOpen(false)}
        onConfirm={onStopConfirm}
      />
    </>
  );
};
